class VisualSearchModal {
  constructor(element) {
    this.element = element;
    this.dialog = element.querySelector('.visual-search-modal__dialog');
    this.input = element.querySelector('[data-visual-search-input]');
    this.dropzone = element.querySelector('[data-visual-search-dropzone]');
    this.preview = element.querySelector('[data-visual-search-preview]');
    this.previewImage = element.querySelector('[data-visual-search-preview-image]');
    this.fileName = element.querySelector('[data-visual-search-file-name]');
    this.status = element.querySelector('[data-visual-search-status]');
    this.results = element.querySelector('[data-visual-search-results]');
    this.grid = element.querySelector('[data-visual-search-grid]');
    this.count = element.querySelector('[data-visual-search-count]');
    this.title = element.querySelector('[data-visual-search-title]');
    this.intro = element.querySelector('[data-visual-search-intro]');
    this.referenceLabel = element.querySelector('[data-visual-search-reference-label]');
    this.productResults = new window.DuvarkaplaVisualProductResults({
      grid: this.grid,
      count: this.count,
      source: 'visual_search',
      idPrefix: 'VisualSearch'
    });
    this.lastFocus = null;
    this.previewUrl = '';
    this.searchRequest = 0;
    this.bind();
  }

  bind() {
    if (!window.DuvarkaplaAITools) {
      document.querySelectorAll('[data-visual-search-open]').forEach((button) => button.addEventListener('click', () => this.open(button)));
    }
    this.element.querySelectorAll('[data-visual-search-close]').forEach((button) => button.addEventListener('click', () => this.close()));
    this.element.querySelector('[data-visual-search-change]').addEventListener('click', () => this.input.click());
    this.input.addEventListener('change', () => this.handleFile(this.input.files[0]));
    ['dragenter', 'dragover'].forEach((eventName) => this.dropzone.addEventListener(eventName, (event) => {
      event.preventDefault();
      this.dropzone.classList.add('is-dragging');
    }));
    ['dragleave', 'drop'].forEach((eventName) => this.dropzone.addEventListener(eventName, (event) => {
      event.preventDefault();
      this.dropzone.classList.remove('is-dragging');
    }));
    this.dropzone.addEventListener('drop', (event) => this.handleFile(event.dataTransfer.files[0]));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.element.hidden) this.close();
    });
  }

  open(button) {
    const parentModal = button?.closest('details-modal');
    this.lastFocus = parentModal?.querySelector('summary') || button || document.activeElement;
    if (parentModal?.isOpen?.()) parentModal.close(false);
    const imageUrl = button?.dataset.visualSearchImage;
    this.element.classList.toggle('is-find-similar', Boolean(imageUrl));
    this.element.hidden = false;
    document.body.classList.add('visual-search-open');
    requestAnimationFrame(() => this.element.classList.add('is-open'));
    this.element.querySelector('.visual-search-modal__close').focus();

    if (imageUrl) {
      this.productResults.setSource('find_similar');
      this.title.textContent = 'Benzer desenleri bulun';
      this.intro.textContent = 'Bu desene görsel olarak en yakın eşleşmeleri keşfedin.';
      this.referenceLabel.textContent = 'Bu desen';
      this.searchProductImage(imageUrl, button.dataset.visualSearchTitle, button.dataset.visualSearchHandle, button.dataset.visualSearchType);
    } else {
      this.productResults.setSource('visual_search');
      this.title.textContent = 'Bir görselden duvar kağıdı bulun';
      this.intro.textContent = 'Referans görselinizi yükleyin, benzer desenleri keşfedin.';
      this.referenceLabel.textContent = 'Referansınız';
      this.dropzone.hidden = false;
      this.preview.hidden = true;
      this.results.hidden = true;
      this.status.hidden = true;
    }
  }

  close() {
    this.element.classList.remove('is-open');
    document.body.classList.remove('visual-search-open');
    setTimeout(() => { this.element.hidden = true; }, 180);
    if (this.lastFocus) this.lastFocus.focus();
  }

  async handleFile(file) {
    if (!file) return;
    if (!file.type.startsWith('image/')) return this.showStatus('Lütfen bir görsel dosyası seçin.', true);
    if (file.size > 5 * 1024 * 1024) return this.showStatus('Görsel çok büyük. Lütfen 5 MB altında bir dosya seçin.', true);

    window.DuvarkaplaFunnel?.trackUpload('visual_search');
    this.productResults.setSource('visual_search');

    this.title.textContent = 'Bir görselden duvar kağıdı bulun';
    this.intro.textContent = 'Referans görselinizi yükleyin, benzer desenleri keşfedin.';
    this.referenceLabel.textContent = 'Referansınız';
    const requestId = ++this.searchRequest;
    this.results.hidden = true;
    this.productResults.clear();
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
    this.previewUrl = URL.createObjectURL(file);
    this.previewImage.src = this.previewUrl;
    this.fileName.textContent = file.name;
    this.dropzone.hidden = true;
    this.preview.hidden = false;
    this.showStatus('<span class="visual-search-spinner"></span><strong>Benzer desenler bulunuyor…</strong><small>Yapay zekâ görselinizi koleksiyonumuzla karşılaştırıyor.</small>');

    try {
      const prepared = await this.prepareImage(file);
      const form = new FormData();
      form.append('image', prepared.blob, 'visual-search.jpg');
      form.append('preferred_type', prepared.width / prepared.height >= 1.15 ? 'Wall Mural' : 'Wallpaper');
      const response = await fetch('https://wallview-duvarkapla.muralls.workers.dev/api/visual-search', { method: 'POST', body: form });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'arama_basarisiz');
      if (requestId !== this.searchRequest) return;
      this.renderProducts(data.products || [], data.groups, data.preferredType);
    } catch (error) {
      if (requestId !== this.searchRequest) return;
      console.error('Visual search error:', error);
      this.showStatus('Bu görselle arama yapılamadı. Lütfen başka bir görsel deneyin.', true);
    }
  }

  async searchProductImage(imageUrl, title, handle, productType) {
    this.productResults.setSource('find_similar');
    const requestId = ++this.searchRequest;
    const normalizedImageUrl = imageUrl.startsWith('//') ? window.location.protocol + imageUrl : imageUrl;
    this.results.hidden = true;
    this.productResults.clear();
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
    this.previewUrl = '';
    this.previewImage.src = normalizedImageUrl;
    this.fileName.textContent = title || 'Mevcut ürün';
    this.dropzone.hidden = true;
    this.preview.hidden = false;
    this.showStatus('<span class="visual-search-spinner"></span><strong>Benzer desenler bulunuyor…</strong><small>Bu görsel koleksiyonumuzla karşılaştırılıyor.</small>');

    try {
      const response = await fetch('https://wallview-duvarkapla.muralls.workers.dev/api/visual-search', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image_url: normalizedImageUrl, exclude_handle: handle || '', preferred_type: productType || '' })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'arama_basarisiz');
      if (requestId !== this.searchRequest) return;
      this.renderProducts(data.products || [], data.groups, data.preferredType);
    } catch (error) {
      if (requestId !== this.searchRequest) return;
      console.error('Similar product search error:', error);
      this.showStatus('Şu anda benzer desenler bulunamadı. Lütfen tekrar deneyin.', true);
    }
  }

  prepareImage(file) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      const url = URL.createObjectURL(file);
      image.onload = () => {
        const scale = Math.min(1, 1200 / Math.max(image.naturalWidth, image.naturalHeight));
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
        canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
        canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(url);
        canvas.toBlob((blob) => blob
          ? resolve({ blob, width: canvas.width, height: canvas.height })
          : reject(new Error('image_conversion_failed')), 'image/jpeg', 0.88);
      };
      image.onerror = () => { URL.revokeObjectURL(url); reject(new Error('image_load_failed')); };
      image.src = url;
    });
  }

  showStatus(message, error = false) {
    this.status.hidden = false;
    this.status.classList.toggle('is-error', error);
    this.status.innerHTML = message;
  }

  renderProducts(products, groups, preferredType) {
    this.status.hidden = true;
    if (!products.length) return this.showStatus('Benzer ürün bulunamadı. Lütfen başka bir görsel deneyin.', true);
    const rendered = this.productResults.render(products, groups, preferredType);
    if (!rendered) return this.showStatus('Benzer ürün bulunamadı. Lütfen başka bir görsel deneyin.', true);
    this.results.hidden = false;
  }
}

const initializeVisualSearch = () => {
  const element = document.getElementById('VisualSearchModal');
  if (element && (!window.duvarkaplaVisualSearch || window.duvarkaplaVisualSearch.deferred)) window.duvarkaplaVisualSearch = new VisualSearchModal(element);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeVisualSearch, { once: true });
} else {
  initializeVisualSearch();
}
